import * as React from 'react';
import { Steps } from "../types";
import ConclusionStep from "./ConclusionStep";
import EmojiStep from "./EmojiStep";
import ReasonStep from "./ReasonStep";





const StepsWrapper = ({ step }) => {
  switch (step) {
    case Steps.Emoji:
      return /*#__PURE__*/React.createElement(EmojiStep, null);
    case Steps.Reason:
      return /*#__PURE__*/React.createElement(ReasonStep, null);
    case Steps.Conclusion:
      return /*#__PURE__*/React.createElement(ConclusionStep, null);
    default:
      return null;}

};

export default StepsWrapper;